import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import servicePeople from 'services/people';

/** @typedef {string} UsePublicResendOptInConfirmationEmailMutationVariables */

/** @typedef {import('services/people').PublicResendOptInConfirmationEmailResponse} PublicResendOptInConfirmationEmailResponse */

/** @typedef {Omit<UseMutationOptions<PublicResendOptInConfirmationEmailResponse, Error, UsePublicResendOptInConfirmationEmailMutationVariables, unknown>, 'mutationKey' | 'mutationFn'>} UsePublicResendOptInConfirmationEmailMutationOptions */

/**
 * Resend the opt-in confirmation email mutation.
 * @param {UsePublicResendOptInConfirmationEmailMutationOptions} [options={}]
 */
export const usePublicResendOptInConfirmationEmailMutation = (options = {}) => {
    return useMutation({
        ...options,
        mutationKey: ['public-resend-opt-in-confirmation-email'],
        /** @param {UsePublicResendOptInConfirmationEmailMutationVariables} personOptInToken */
        mutationFn: personOptInToken => servicePeople.publicResendOptInConfirmationEmail(personOptInToken)
    });
};
